// import React from "react";
// import { Autocomplete, TextField } from "@mui/material";

// const VehicleAutocomplete = ({
//   vehicleList,
//   selectedVehicle,
//   onVehicleChange,
// }) => {
//   return (
//     <Autocomplete
//       id="vehicle_no"
//       name="vehicle_no"
//       options={vehicleList}
//       getOptionLabel={(option) => option.vehicle_no}
//       value={vehicleList.find(
//         (option) => option.vehicle_no === selectedVehicle
//       )}
//       onChange={(event, newValue) =>
//         onVehicleChange(newValue ? newValue.vehicle_no : "")
//       }
//       renderInput={(params) => (
//         <TextField
//           {...params}
//           variant="outlined"
//           placeholder="Select Vehicle No"
//           fullWidth
//         />
//       )}
//     />
//   );
// };

// export default VehicleAutocomplete;

import * as React from "react";
import { useTheme } from "@mui/material/styles";
import OutlinedInput from "@mui/material/OutlinedInput";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

const VehicleAutocomplete = ({
  vehicleList,
  selectedVehicles,
  onVehicleChange,
}) => {
  const theme = useTheme();
  // Initialize state with an empty array if selectedVehicles is not provided
  const [selectedVehicleNos, setSelectedVehicleNos] = React.useState(
    selectedVehicles || []
  );

  const handleChange = (event) => {
    const {
      target: { value },
    } = event;
    // Ensure the value is an array
    const newValues = typeof value === "string" ? value.split(",") : value;
    setSelectedVehicleNos(newValues);
    onVehicleChange(newValues);
  };

  return (
    <FormControl sx={{ m: 1 }} style={{ width: "100%" }}>
      <Select
        multiple
        value={selectedVehicleNos}
        onChange={handleChange}
        input={<OutlinedInput />}
        renderValue={(selected) => {
          if (selected.length === 0) {
            return <em>Select Vehicle No</em>;
          }
          return selected.join(", ");
        }}
        MenuProps={MenuProps}
      >
        <MenuItem disabled value="">
          <em>Select Vehicle No</em>
        </MenuItem>
        {vehicleList.map((vehicle) => (
          <MenuItem
            key={vehicle.vehicle_no}
            value={vehicle.vehicle_no}
            style={{
              fontWeight:
                selectedVehicleNos.indexOf(vehicle.vehicle_no) !== -1
                  ? theme.typography.fontWeightMedium
                  : theme.typography.fontWeightRegular,
            }}
          >
            {vehicle.vehicle_no}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default VehicleAutocomplete;
